var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExitButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_97_1969",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "#777777"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_97_1969)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.001 23.75C24.6468 23.75 24.3499 23.6302 24.1104 23.3906C23.8708 23.151 23.751 22.8542 23.751 22.5V18.75C23.751 17.7083 23.3864 16.8229 22.6572 16.0938C21.9281 15.3646 21.0426 15 20.001 15H8.50098L12.1572 18.6563C12.3864 18.8854 12.501 19.1667 12.501 19.5C12.501 19.8333 12.376 20.125 12.126 20.375C11.8968 20.6042 11.6051 20.7188 11.251 20.7188C10.8968 20.7188 10.6051 20.6042 10.376 20.375L4.62598 14.625C4.50098 14.5 4.41243 14.3646 4.36035 14.2188C4.30827 14.0729 4.28223 13.9167 4.28223 13.75C4.28223 13.5833 4.30827 13.4271 4.36035 13.2813C4.41243 13.1354 4.50098 13 4.62598 12.875L10.4072 7.09375C10.6364 6.86458 10.9176 6.75 11.251 6.75C11.5843 6.75 11.876 6.875 12.126 7.125C12.3551 7.35417 12.4697 7.64583 12.4697 8C12.4697 8.35417 12.3551 8.64583 12.126 8.875L8.50098 12.5H20.001C21.7301 12.5 23.2041 13.1094 24.4229 14.3281C25.6416 15.5469 26.251 17.0208 26.251 18.75V22.5C26.251 22.8542 26.1312 23.151 25.8916 23.3906C25.652 23.6302 25.3551 23.75 25.001 23.75Z",
    fill: "#777777"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitButton);
export default __webpack_public_path__ + "static/media/ExitButton.50e8277d22d7b3f3e35ccb0987b2d486.svg";
export { ForwardRef as ReactComponent };